import type { WatchDto } from "./generated/WatchDto";

/** The watch kinds the server accepts (mirrors the Rust CHECK constraint). */
export type WatchKind = "supplier_reply" | "contract_expiry" | "deal_stale";

export type WatchEntityType = "deal" | "customer";

/** Human labels — what each kind is watching for. */
export const WATCH_KIND_LABELS: Record<WatchKind, string> = {
  supplier_reply: "Supplier reply",
  contract_expiry: "Contract expiring",
  deal_stale: "Deal untouched",
};

export type Watch = Omit<WatchDto, "watch_kind" | "entity_type"> & {
  watch_kind: WatchKind;
  entity_type: WatchEntityType;
};
